// extracted by mini-css-extract-plugin
module.exports = {"headerBar":"HeaderBar_headerBar__1hrKn","title":"HeaderBar_title__abUC8","myAccount":"HeaderBar_myAccount__2kZC_","additionalContent":"HeaderBar_additionalContent__3YHR3"};